const findQuestion = (question, questions) => {
  return new Promise((res, rej) => {
    res(questions.find((qs) => qs.question === question));
  });
};

export default findQuestion;
